<template>
	<div class="container">
		<img src="@/assets/images/ornament-circle-bottom.svg" alt="bottom-image-ornament" class="home-ornament-bottom">
		<div class="product-content content-default">
			<h1 class="title-default primary">
				<div class="text">My Products</div>
				<img src="@/assets/images/title-ornament.svg" alt="title-ornament" class="w-ornament">
			</h1>
			<div class="row">
				<div class="col-12 col-md-3 col-lg-3">
					<button 
					@click="activeFilter = !activeFilter"
					class="btn-default text-center no-shadow no-gradient-hover 
					hide-xl hide-lg hide-md show
					mb-30">
					<img src="@/assets/images/icon/filter.svg" alt="filter-icon" class="icon-default"
					style="margin-top: -4px;">
					Filter</button>
					<div class="wrapper-filter hide" :class="{'active': activeFilter}">
						<div class="form-group checkbox-wrapper">
							<label class="checkbox path">
								<input type="checkbox" id="Graphic Design" value="Graphic Design" v-model="filterProduct.category">
								<CheckboxSvg />
							</label>
							<label class="title-checkbox" for="Graphic Design">Graphic Design</label>
						</div>
						<div class="form-group checkbox-wrapper">
							<label class="checkbox path">
								<input type="checkbox" id="uiux" value="UI / UX" v-model="filterProduct.category">
								<CheckboxSvg />
							</label>
							<label class="title-checkbox" for="uiux">UI / UX</label>
						</div>
						<div class="form-group checkbox-wrapper">
							<label class="checkbox path">
								<input type="checkbox" id="web-template" value="Web Template" v-model="filterProduct.category">
								<CheckboxSvg />
							</label>
							<label class="title-checkbox" for="web-template">Web Template</label>
						</div>
						<div class="form-group checkbox-wrapper">
							<label class="checkbox path">
								<input type="checkbox" id="code-library" value="Code / Library" v-model="filterProduct.category">
								<CheckboxSvg />
							</label>
							<label class="title-checkbox" for="code-library">Code / Library</label>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-9 col-lg-9">
					<div class="text-center" v-if="productAvailable">
						<img src="@/assets/images/empty-state.svg" alt="empty-state" style="width: 250px;">
					</div>
					<div class="row justify-content-start" v-if="!loadProducts">
						<div class="col-12 col-md-6 col-lg-4 box-product-wrapper" v-for="(item, index) in dataProducts" :key="item.key+index">
							<div class="box-product">
								<router-link :to="'/products/'+item.key">
									<img v-lazy="item.imageThumbnail" class="image-product" alt="image-product" style="width: 100%; border: 1px solid #f2f2f2; border-radius: 5px;">
								</router-link>
								<router-link 
								class="link-default"
								:to="'/products/slug'"><h2 class="title">{{item.title}}</h2></router-link>
								<div class="d-flex">
									<p class="price">{{item.price == 0 ? 'Free' : currency(item.price)}}</p>
									<p class="mx-5">/</p>
									<p class="price">{{item.category[0]}}</p>
								</div>
							</div>
						</div>
					</div>

					<div class="row" v-else>
						<div class="col-12 col-md-6 col-lg-4" v-for="index in 12" :key="index">
							<skeleton-loading>
								<square-skeleton :boxProperties="{
									bottom: '15px',
									width: '100%',
									height: '160px'
									}">
								</square-skeleton>
								<square-skeleton :boxProperties="{
								bottom: '15px',
								width: '100%',
								height: '15px'
								}">
								</square-skeleton>
								
								<square-skeleton :boxProperties="{
								bottom: '15px',
								width: '50%',
								height: '15px'
								}">
								</square-skeleton>
							</skeleton-loading>
						</div>
					</div>

					<div class="text-center pb-30" v-if="loadNextProducts">
						<Loader/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import CheckboxSvg from '@/components/CheckboxSvg'
	import Loader from '@/components/Loader'

	import firebase from 'firebase/app'

	let LAST_VISIBLE
	let PRODUCT_COUNT
	const LIMIT = 12

	export default {
		metaInfo: {
			title: 'Products - Jung Rama'
		},
		data(){
			return{
				activeFilter: false,
				loadProducts: true,
				loadNextProducts: false,
				productAvailable: false,
				
				filterProduct:{
					category: [],
					price: []
				},
				dataProducts: []
			}
		},
		components: {
			CheckboxSvg,
			Loader
		},
		methods:{
			currency(value){
				const val = parseInt(value)
				return '$' + val.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
			},
			queryFilter(){
				let query = firebase.firestore()
							.collection('products')

				if(this.filterProduct.category.length > 0){
					query = firebase.firestore()
					.collection('products')
					.where('category', 'array-contains-any', this.filterProduct.category);
				}

				return query
			},
			countProductData(){
				this.queryFilter()
				.get().then(querySnapshoot => {
					PRODUCT_COUNT = querySnapshoot.size
				})
				.catch(err => {
					console.log({er : err});
					
					this.$router.push('/404')
				})
			},
			getProductData(){

				this.loadProducts = true
				this.productAvailable = false
				
				this.queryFilter()
				.orderBy('lastUpdated', 'desc')
				.limit(LIMIT)
				.get()
				.then(async querySnapshoot => {

					if(querySnapshoot.size <= 0){
						this.productAvailable = true
						this.loadProducts = false
						this.dataProducts = []
					}else{
						LAST_VISIBLE = querySnapshoot.docs[querySnapshoot.docs.length-1];
					
						const product = await querySnapshoot.docs.map(doc =>{
							return {
								key: doc.id,
								...doc.data()
							}
						})
						
						this.productAvailable = false
						this.loadProducts = false
						this.dataProducts = product

						if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
							if(this.dataProducts.length < PRODUCT_COUNT){
								this.getNextProductData()
							}
						}
					}
					
				})

			},
			getNextProductData(){
				this.loadNextProducts = true

				this.queryFilter()
				.orderBy('lastUpdated', 'desc')
				.startAfter(LAST_VISIBLE)
				.limit(LIMIT)
				.get()
				.then(async querySnapshoot => {
					LAST_VISIBLE = querySnapshoot.docs[querySnapshoot.docs.length-1];
					
					const product = await querySnapshoot.docs.map(doc =>{
						return {
							key: doc.id,
							...doc.data()
						}
					})

					this.loadNextProducts = false
					this.dataProducts.push(...product)
				})
			},
			scroll () {
				window.onscroll = () => {
					if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
						if(this.dataProducts.length < PRODUCT_COUNT){
							this.getNextProductData()
						}
					}
				};
			},
		},
		watch: {
			'filterProduct.category': function() {
				this.countProductData()
				this.getProductData()
			}
		},
		async mounted(){
			await this.countProductData()
			await this.getProductData()
			await this.scroll();
		}
	}
</script>